import React, { useEffect, useState } from 'react';
import './StartPagePrompt.css';
import logger from '../../utils/logger';
import languageManager from '../../utils/languageManager';

const StartPagePrompt = ({ onClose, delaySeconds = 8 }) => {
  const [visible, setVisible] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [browser, setBrowser] = useState('');

  // 组件挂载后，延迟显示提示
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
      // 检测用户使用的浏览器
      detectBrowser();
    }, delaySeconds * 1000);

    return () => clearTimeout(timer);
  }, [delaySeconds]);

  // 检测浏览器类型
  const detectBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    
    if (userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg') > -1) {
      setBrowser('edge');
    } else if (userAgent.indexOf('chrome') > -1) {
      setBrowser('chrome');
    } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
      setBrowser('safari');
    } else if (userAgent.indexOf('firefox') > -1) {
      setBrowser('firefox');
    } else if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
      setBrowser('ie');
    } else {
      setBrowser('other');
    }
  };

  // 设置为起始页面的方法
  const handleSetStartPage = () => {
    try {
      const { protocol, host, pathname } = window.location;
      const homepageUrl = `${protocol}//${host}${pathname}`;
      
      // 检查是否可以使用旧方法（主要是IE或较旧浏览器）
      if (window.external && typeof window.external.AddFavorite === 'function') {
        window.external.AddFavorite(homepageUrl, document.title);
        onClose('accepted');
        return;
      }
      
      // 对于现代浏览器，展示根据浏览器类型定制的说明
      setShowInstructions(true);
      
    } catch (e) {
      // 如果任何方法失败，显示指导说明
      setShowInstructions(true);
    }
  };

  // 取消设置
  const handleCancel = () => {
    onClose('rejected');
  };

  // 关闭指导说明，记录用户已被提示
  const handleCloseInstructions = () => {
    onClose('accepted');
  };

  // 复制当前URL到剪贴板
  const copyToClipboard = async () => {
    const { protocol, host, pathname } = window.location;
    const homepageUrl = `${protocol}//${host}${pathname}`;
    
    try {
      await navigator.clipboard.writeText(homepageUrl);
      alert(languageManager.t('startPagePrompt.urlCopied'));
    } catch (err) {
      logger.error('复制失败: ', err);
      // 提供备选方案
      const textArea = document.createElement('textarea');
      textArea.value = homepageUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert(languageManager.t('startPagePrompt.urlCopied'));
    }
  };

  // 根据浏览器类型返回设置说明
  const getBrowserInstructions = () => {
    switch (browser) {
      case 'chrome':
        return (
          <>
            <h4>{languageManager.t('startPagePrompt.chromeTitle')}</h4>
            <ol>
              {languageManager.t('startPagePrompt.chromeInstructions').map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </>
        );
      case 'edge':
        return (
          <>
            <h4>{languageManager.t('startPagePrompt.edgeTitle')}</h4>
            <ol>
              {languageManager.t('startPagePrompt.edgeInstructions').map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </>
        );
      case 'firefox':
        return (
          <>
            <h4>{languageManager.t('startPagePrompt.firefoxTitle')}</h4>
            <ol>
              {languageManager.t('startPagePrompt.firefoxInstructions').map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </>
        );
      case 'safari':
        return (
          <>
            <h4>{languageManager.t('startPagePrompt.safariTitle')}</h4>
            <ol>
              {languageManager.t('startPagePrompt.safariInstructions').map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </>
        );
      default:
        return (
          <>
            <h4>{languageManager.t('startPagePrompt.defaultTitle')}</h4>
            <p>{languageManager.t('startPagePrompt.defaultInstructions')}</p>
          </>
        );
    }
  };

  if (!visible) return null;

  if (showInstructions) {
    return (
      <div className="start-page-prompt-overlay">
        <div className="start-page-prompt-container instructions-container">
        <div className="start-page-prompt-header">
          <h3>{languageManager.t('startPagePrompt.howToSet')}</h3>
          <button className="close-button" onClick={handleCloseInstructions}>×</button>
        </div>
        <div className="start-page-prompt-content">
          {getBrowserInstructions()}
          
          <div className="url-copy-container">
            <div className="url-display">{window.location.href}</div>
            <button className="copy-button" onClick={copyToClipboard}>{languageManager.t('startPagePrompt.copyUrl')}</button>
          </div>
          
          <div className="start-page-prompt-buttons">
            <button className="confirm-button" onClick={handleCloseInstructions}>{languageManager.t('startPagePrompt.IHaveSet')}</button>
          </div>
        </div>
        </div>
      </div>
    );
  }

  return (
    <div className="start-page-prompt-overlay">
      <div className="start-page-prompt-container">
        <div className="start-page-prompt-header">
          <h3>{languageManager.t('startPagePrompt.title')}</h3>
          <button className="close-button" onClick={handleCancel}>×</button>
        </div>
        <div className="start-page-prompt-content">
          <p>{languageManager.t('startPagePrompt.description')}</p>
          <div className="start-page-prompt-buttons">
            <button className="cancel-button" onClick={handleCancel}>{languageManager.t('startPagePrompt.cancel')}</button>
            <button className="confirm-button" onClick={handleSetStartPage}>{languageManager.t('startPagePrompt.setAsHomepage')}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartPagePrompt; 